import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { ResiduoPatogenicoSchema } from "../data/ResiduoPatogenicoSchema";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import TextField from "./controls/TextField";
import AmmountField from "./controls/AmmountField";
import CheckboxField from "./controls/CheckboxField";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";
import { isInvalid } from "../utils/forms";

export function ResiduoPatogenicoForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  operacionesUnitarias,
  unidadCantidad,
  disabled,
}) {
  const { t } = useTranslation();
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnChange={true}
      validationSchema={ResiduoPatogenicoSchema}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(residuoPatogenicoForm) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("residuoPatogenicoForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <TextField
                id="residuoPatogenico_descripcion"
                name="descripcion"
                label={t("residuoPatogenico.descripcion")}
                value={residuoPatogenicoForm.values?.descripcion}
                onChange={(event) => residuoPatogenicoForm.handleChange(event)}
                isInvalid={isInvalid("descripcion", residuoPatogenicoForm)}
                error={t(residuoPatogenicoForm.errors.descripcion)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <AmmountField
                id="residuoPatogenico_cantidad"
                name="cantidad"
                label={t("residuoPatogenico.cantidad")}
                value={residuoPatogenicoForm.values?.cantidad}
                onChange={(event) => residuoPatogenicoForm.handleChange(event)}
                unit={unidadCantidad}
                isInvalid={isInvalid("cantidad", residuoPatogenicoForm)}
                error={t(residuoPatogenicoForm.errors.cantidad)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <CheckboxField
                id="residuoPatogenico_operacionesUnitaria"
                name="operacionesUnitarias"
                label={t("residuoPatogenico.operacionesUnitarias")}
                value={residuoPatogenicoForm.values?.operacionesUnitarias}
                onChange={(event) => residuoPatogenicoForm.handleChange(event)}
                options={operacionesUnitarias}
                labelAttr="nombre"
                valueAttr="orden"
                lg={6}
                isInvalid={isInvalid(
                  "AlertoperacionesUnitarias",
                  residuoPatogenicoForm,
                )}
                error={t(residuoPatogenicoForm.errors.operacionesUnitarias)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={6}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={6}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="success"
                    value={t("residuoPatogenicoForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("residuoPatogenicoForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}

                <Button
                  sm
                  variant="primary"
                  value={t("residuoPatogenicoForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    residuoPatogenicoForm.submitForm();
                  }}
                  disabled={disabled}
                />
                {page === -1 && pages > 0 && (
                  <Button
                    sm
                    variant="default"
                    value={t("residuoPatogenicoForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(0);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
